import { render, h } from "preact";
import MuxReact from "../components/MuxReact.js";

const muxVideos = document.querySelectorAll("[data-mux-render]");

muxVideos.forEach((container) => {
  const muxOptions = {
    streamType: "on-demand",
    loading: container.dataset.loading ? container.dataset.loading : "viewport",
    poster: container.dataset.poster,
    preload: container.dataset.preload,
    playbackId: container.dataset.videoId,
    className: container.dataset.classes,
  };
  if (container.dataset.autoplay == "true") {
    muxOptions.autoPlay = container.dataset.autoplay;
  }
  render(h(MuxReact, muxOptions), container);
});
